import { Award, TrendingUp, Users, CheckCircle } from "lucide-react";

const About = () => {
    const stats = [
        { label: "Years of Experience", value: "30+", icon: <Award className="text-accent mb-2" /> },
        { label: "Satisfied Clients", value: "500+", icon: <Users className="text-accent mb-2" /> },
        { label: "Metric Tonnes Traded", value: "10k+", icon: <TrendingUp className="text-accent mb-2" /> },
    ];

    const features = [
        "Unwavering Commitment to Quality",
        "State-of-the-art Cutter Plant",
        "Direct Sourcing from SAIL",
        "Timely Delivery Network",
        "Custom Fabrication Solutions",
        "Transparent Business Practices",
    ];

    return (
        <section id="about" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    {/* Content */}
                    <div className="space-y-8">
                        <div>
                            <h2 className="text-accent font-bold tracking-wide uppercase text-sm mb-3">Who We Are</h2>
                            <h3 className="text-3xl md:text-5xl font-bold font-heading text-primary mb-6">
                                Defining Standards in <br /> Steel Trading
                            </h3>
                            <p className="text-slate-600 text-lg leading-relaxed">
                                Since 1996, <strong>Uma Ispat Private Limited</strong> has been a cornerstone in the iron and steel industry.
                                We don't just trade steel; we build relationships founded on trust and integrity.
                            </p>
                            <p className="text-slate-600 text-lg leading-relaxed">
                                With the recent addition of our state-of-the-art cutter plant in Bokaro,
                                we have evolved from traders to comprehensive solution providers,
                                ensuring that every piece of metal meets the highest standards of precision.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {features.map((feature, idx) => (
                                <div key={idx} className="flex items-center gap-3 text-slate-700">
                                    <CheckCircle size={20} className="text-accent shrink-0" />
                                    <span className="font-medium">{feature}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Experience & Clients Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div className="bg-slate-50 p-8 rounded-2xl flex flex-col justify-center items-center text-center border border-slate-100 shadow-sm transition-all hover:shadow-md">
                            <Award className="text-accent mb-3" size={32} />
                            <h4 className="text-5xl font-bold font-heading text-primary mb-2">30+</h4>
                            <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">Years of Experience</p>
                        </div>
                        <div className="bg-slate-50 p-8 rounded-2xl flex flex-col justify-center items-center text-center border border-slate-100 shadow-sm transition-all hover:shadow-md">
                            <Users className="text-accent mb-3" size={32} />
                            <h4 className="text-5xl font-bold font-heading text-primary mb-2">500+</h4>
                            <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">Satisfied Clients</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
